import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { useRouter } from "@tanstack/react-router";
import { Button } from "./catalyst/Button";
import { Logo } from "./Logo";

/**
 * Global 404 Not Found component for invalid routes.
 * Shows a friendly message with navigation options.
 */
export function NotFound() {
	const router = useRouter();

	const handleGoHome = () => {
		router.navigate({ to: "/" });
	};

	const handleGoBack = () => {
		router.history.back();
	};

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-base-100">
			{/* Animated background gradient */}
			<div className="absolute inset-0 overflow-hidden">
				<div
					className="absolute -left-1/4 top-0 h-96 w-96 animate-pulse rounded-full bg-primary/5 blur-3xl"
					style={{ animationDuration: "4s" }}
				/>
				<div
					className="absolute -right-1/4 bottom-0 h-96 w-96 animate-pulse rounded-full bg-secondary/5 blur-3xl"
					style={{ animationDuration: "6s", animationDelay: "1s" }}
				/>
			</div>

			<div className="relative z-10 flex max-w-lg flex-col items-center gap-8 px-6 text-center">
				{/* Logo */}
				<div className="text-base-content/50">
					<Logo />
				</div>

				{/* 404 with animated search icon */}
				<div className="relative">
					{/* Large 404 text */}
					<div className="text-8xl font-bold text-base-content/10">404</div>
					{/* Floating search icon */}
					<div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
						<div className="relative">
							<div
								className="absolute -inset-4 animate-ping rounded-full bg-primary/10"
								style={{ animationDuration: "3s" }}
							/>
							<div className="flex h-16 w-16 items-center justify-center rounded-full bg-base-200 ring-2 ring-base-300">
								<MagnifyingGlassIcon className="h-8 w-8 text-base-content/50" />
							</div>
						</div>
					</div>
				</div>

				{/* Message */}
				<div className="space-y-3">
					<h1 className="text-2xl font-bold text-base-content">
						Page not found
					</h1>
					<p className="text-base-content/60">
						The page you're looking for doesn't exist or may have been moved.
					</p>
				</div>

				{/* Action buttons */}
				<div className="flex flex-wrap items-center justify-center gap-4">
					<Button onClick={handleGoHome} color="blue">
						Go to dashboard
					</Button>
					<Button onClick={handleGoBack} outline>
						Go back
					</Button>
				</div>
			</div>
		</div>
	);
}
